import { useEffect, useRef, useState } from "react";
import { Global_Data } from "../../globalData/GlobalData";
import { serverAddress } from "../../config";
import ComponentLoadingBoundary from "../Loading/ComponentLoadingBoundary";
import usePendingRequests from "../Loading/usePendingRequests";

function PdfViewer({ uri }) {
  const { token } = Global_Data() || {};
  const [fileUrl, setFileUrl] = useState("");
  const objectUrlRef = useRef("");
  const { loading, trackRequest } = usePendingRequests();

  const isUriReady =
    uri &&
    !uri.includes("{") &&
    !uri.includes("}") &&
    !uri.includes("[") &&
    !uri.includes("]");

  useEffect(() => {
    if (!isUriReady || !token) return;

    let cancelled = false;

    trackRequest(async () => {
        const res = await fetch(`${serverAddress}${uri}`, {
          method: "GET",
          headers: {
            Accept: "application/pdf",
            Authorization: `Bearer ${token}`
          }
        });
        const blob = await res.blob();

        if (!res.ok) {
          throw new Error(`PDF request failed: ${res.status}`);
        }

        if (cancelled) return;

        if (objectUrlRef.current) {
          URL.revokeObjectURL(objectUrlRef.current);
        }

        const nextUrl = URL.createObjectURL(blob);
        objectUrlRef.current = nextUrl;
        setFileUrl(nextUrl);
      })
      .catch(error => {
        console.error("[PDFViewer] fetch error:", error);
      });

    return () => {
      cancelled = true;
    };
  }, [uri, token, isUriReady]);

  useEffect(() => {
    return () => {
      if (objectUrlRef.current) {
        URL.revokeObjectURL(objectUrlRef.current);
      }
    };
  }, []);

  return (
    <ComponentLoadingBoundary
      loading={loading}
      label="Loading PDF"
      minHeight={240}
      size={28}
    >
      {fileUrl && (
        <iframe
          src={`${fileUrl}#zoom=page-width`}
          title="PDF Viewer"
          style={{
            width: "100%",
            height: "85vh",
            border: "none",
            display: "block",
            backgroundColor: "#ffffff"
          }}
        />
      )}
    </ComponentLoadingBoundary>
  );
}

export default PdfViewer;
